import { useEffect, useState, useMemo, useCallback, useRef } from "react";
import middleware from "../../../../Api/Middleware";
import TablePreset from "../../../../Table/TablePreset";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import ConfirmationModal from "../../../../Modals/ConfirmationModal";
import { useTable } from "react-table";
import ToastError from "../../../../Toasts/ToastError";
import ToastSuccess from "../../../../Toasts/ToastSuccess";
import CurrencyInput from "react-currency-input-field";
import {
  BorderedSquareNumberInput,
  BorderedSquareTextInput,
} from "../../../../HouseStyle/Components/Inputs";
import { RegularCheckBox } from "../../../../HouseStyle/Components/Checkboxes";
import ToastWarning from "../../../../Toasts/ToastWarning";
import generateLabel from "../../../../generatePDF/GenerateLabel";
import { formatCurrency } from "../../../../../utils";

const BoxVariation = (props) => {
  const [addVariation, setAddVariation] = useState({
    size: "",
    color: "",
  });
  const [sizeVariations, setSizeVariations] = useState([]);
  const [variations, setVariations] = useState([]);
  const [colorVariations, setColorVariations] = useState([]);
  const [selectedVariationIds, setSelectedVariationIds] = useState([]);
  const [duplicateInstalled, setDuplicateInstalled] = useState(JSON.parse(localStorage.getItem("appstore")));
  const [selectedIds, setSelectedIds] = useState([]);
  const [labelPrinterInstalled, setLabelPrinterInstalled] = useState(localStorage.getItem("labelPrinterInstalled") === "true");
  const [sizeFilter, setSizeFilter] = useState("");
  const [colorFilter, setColorFilter] = useState("");
  const [isExecuted, setIsExecuted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  // barcode overwrite confirmation
  const [showGenerateConfirm, setShowGenerateConfirm] = useState(false);
  const pendingConfirmActionRef = useRef(null);
  const [pagination, setPagination] = useState({
    page_size: 10,
    page: 1,
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  });

  // Check if label printer app is installed
  useEffect(() => {
    const checkLabelPrinterInstallation = async () => {
      try {
        const response = await middleware.get(`apps?app_id=6`);
        const isInstalled = response.data.data.status === 3;
        localStorage.setItem("labelPrinterInstalled", isInstalled);
        setLabelPrinterInstalled(isInstalled);
      } catch (error) {
        console.error("Error checking label printer installation:", error);
      }
    };
    
    checkLabelPrinterInstallation();
  }, []);

  useEffect(() => {
    // invalid prices
    const invalidValues = [null, 0, "", " ", "0", "0.00"];
    const isValid = (price) => !invalidValues.includes(price);

    // get baseprice (sale price if filled in)
    let basePrice;
    if (
      isValid(
        props.prices.find((item) => item.type === "sale_price")?.incl_tax ??
        null
      )
    ) {
      basePrice = props.prices
        ? Number(
          props.prices.find((item) => item.type === "sale_price")?.incl_tax
        )
        : 0;
    } else {
      basePrice = props.prices
        ? Number(props.prices.find((item) => item.type === "price")?.incl_tax)
        : 0;
    }
    // loop trough all variations
    props.allVariations.forEach((variation) => {
      // set + or - operator button
      // execute only 1 time when the page is loaded
      if (!isExecuted) {
        const varPrice = variation.prices.find(
          (item) => item.type === "price"
        )?.incl_tax;
        if (Number(varPrice) > Number(basePrice)) {
          props.setAllVariations((prev) =>
            prev.map((item) =>
              item.id === variation.id
                ? { ...item, variation_operator: "+" }
                : item
            )
          );
        } else if (Number(varPrice) < Number(basePrice)) {
          props.setAllVariations((prev) =>
            prev.map((item) =>
              item.id === variation.id
                ? { ...item, variation_operator: "-" }
                : item
            )
          );
        }
      }
      // Calculate final price for each variation if not updated already
      if (!isUpdated) {
        calculateFinalPrice(variation);
      }
    });
    if (props.allVariations.length > 0) {
      setIsExecuted(true);
    }
    setIsUpdated(false);
  }, [props.allVariations, props.prices]);

  const updatePagination = useCallback(() => {
    // Filter de variaties op basis van de geselecteerde filters
    const colorFiltered =
      colorFilter !== "" && colorFilter !== null
        ? props.allVariations.filter(
          (e) => e.colors && e.colors[0]?.color_id == colorFilter
        )
        : props.allVariations;

    const sizeFiltered =
      sizeFilter !== "" && sizeFilter !== null
        ? colorFiltered.filter(
          (e) => e.sizes && e.sizes[0]?.size_id == sizeFilter
        )
        : colorFiltered;

    const totalVariations = sizeFiltered.length;

    const { page_size, page } = pagination;
    const maxPage = Math.ceil(totalVariations / page_size);
    const newPage = Math.max(1, page > maxPage ? maxPage : page);

    const begin_of_page = (newPage - 1) * page_size;
    const end_of_page = Math.min(begin_of_page + page_size, totalVariations);

    const paginatedVariations = sizeFiltered.slice(begin_of_page, end_of_page);

    setPagination((prev) => ({
      ...prev,
      max_items: totalVariations,
      page: newPage,
      begin_of_page: totalVariations === 0 ? 0 : begin_of_page + 1,
      end_of_page: end_of_page,
    }));

    setVariations(paginatedVariations);
  }, [
    props.allVariations,
    colorFilter,
    sizeFilter,
    pagination.page_size,
    pagination.page,
  ]);

  // Update de variaties zodra de pagination verandert
  useEffect(() => {
    updatePagination();
  }, [
    pagination.page_size,
    pagination.page,
    props.allVariations,
    colorFilter,
    sizeFilter,
  ]);

  const handleProductSelection = (productId, isSelected) => {
    if (isSelected) {
      setSelectedVariationIds([...selectedVariationIds, productId]);
    } else {
      setSelectedVariationIds(
        selectedVariationIds.filter((id) => id !== productId)
      );
    }
  };

  const handleSelection = (id, isSelected) => {
    if (isSelected) {
      setSelectedIds((previous) => [...previous, id]);
    } else {
      setSelectedIds((previous) => previous.filter((id) => id !== id));
    }
  };

 const generate_barcodes = async () => {
  if (selectedVariationIds.length === 0) {
    ToastError('Geen variaties geselecteerd', 'barcode_generate_error');
    return;
  }

  try {
    // First, validate that all selected variations exist
    const validVariations = [];
    const missingIds = [];
    
    selectedVariationIds.forEach((selectedId) => {
      const variation = props.allVariations.find(
        (variation) => variation.id === selectedId || variation.id == selectedId
      );
      
      if (variation) {
        validVariations.push(variation);
      } else {
        missingIds.push(selectedId);
      }
    });

    if (missingIds.length > 0) {
      console.warn('Missing variations:', missingIds);
      ToastWarning(`Sommige variaties niet gevonden: ${missingIds.join(', ')}. Doorgaan met ${validVariations.length} variaties.`);
    }

    if (validVariations.length === 0) {
      ToastError('Geen geldige variaties gevonden', 'barcode_generate_error');
      return;
    }

    let hasExisting = validVariations.some(v => {
      const val = v?.barcode?.barcode ?? (typeof v?.barcode === 'string' ? v.barcode : null);
      return val != null && String(val).trim() !== "";
    });

    if (hasExisting) {
      const idsToGenerate = validVariations.map(v => v.id);
      pendingConfirmActionRef.current = () => performBulkGenerate(idsToGenerate);
      setShowGenerateConfirm(true);
      return;
    }

    // Generate barcodes for valid variations only
    const generated_barcodes = await generateMultipleBarcodes(validVariations.length);
    
    if (!generated_barcodes || generated_barcodes.length === 0) {
      ToastError('Geen barcodes gegenereerd door de server', 'barcode_generate_error');
      return;
    }

    // Work with whatever barcodes we got - don't require exact match
    const availableBarcodes = Math.min(generated_barcodes.length, validVariations.length);
    
    if (generated_barcodes.length < validVariations.length) {
      console.warn(`Only got ${generated_barcodes.length} barcodes for ${validVariations.length} variations`);
      ToastWarning(`Slechts ${generated_barcodes.length} van ${validVariations.length} barcodes ontvangen. Doorgaan met beschikbare barcodes.`);
    }

    let generatedCount = 0;
    const errors = [];
    
    // Process only the available barcodes
    for (let i = 0; i < availableBarcodes; i++) {
      const variation = validVariations[i];
      const barcode = generated_barcodes[i];
      
      if (!barcode || barcode === '') {
        errors.push(`Lege barcode ontvangen voor variatie ${variation.id}`);
        continue;
      }
      
      try {
        handleBarcodeChange(barcode, variation.id);
        generatedCount++;
      } catch (error) {
        console.error(`Error assigning barcode to variation ${variation.id}:`, error);
        errors.push(`Fout bij het toewijzen van barcode aan variatie ${variation.id}: ${error.message}`);
      }
    }
    
    // Trigger save to database if any barcodes were assigned
    if (generatedCount > 0) {
      props.setUpdatedVariations(true);
    }
    
    // Show results
    if (errors.length > 0) {
      console.error('Barcode generation errors:', errors);
      ToastError(`Fouten bij ${errors.length} variaties: ${errors.slice(0, 2).join(', ')}${errors.length > 2 ? '...' : ''}`, 'barcode_generate_error');
    }
    
    if (generatedCount > 0) {
      ToastSuccess(`${generatedCount} barcode(s) succesvol gegenereerd en toegewezen`, 'barcode_generate_success');
    } else {
      ToastError('Geen barcodes konden worden toegewezen', 'barcode_generate_error');
    }
    
  } catch (error) {
    console.error('Error in generate_barcodes:', error);
    ToastError('Onverwachte fout bij het genereren van barcodes: ' + error.message, 'barcode_generate_error');
  }
};

// Enhanced generateMultipleBarcodes with better error handling
const generateMultipleBarcodes = async (amount) => {
  try {
    const response = await middleware.get(
      `products/generateMultipleBarcodes?barcodeAmount=${amount}`
    );
    
    if (!response || !response.data) {
      throw new Error('Geen response data ontvangen van server');
    }
    
    let newBarcodes = response.data.generatedBarcode;
    
    // Handle different response formats
    if (!newBarcodes) {
      // Try alternative property names
      newBarcodes = response.data.barcodes || response.data.generatedBarcodes || response.data;
    }
    
    // Ensure newBarcodes is always an array
    if (!Array.isArray(newBarcodes)) {
      if (newBarcodes && typeof newBarcodes === 'string') {
        newBarcodes = [newBarcodes];
      } else if (newBarcodes && typeof newBarcodes === 'object') {
        // If it's an object, try to extract values
        newBarcodes = Object.values(newBarcodes);
      } else {
        newBarcodes = [];
      }
    }
    
    // Filter out any null, undefined, or empty string barcodes
    newBarcodes = newBarcodes.filter(barcode => 
      barcode != null && 
      barcode !== '' && 
      typeof barcode === 'string' && 
      barcode.trim() !== ''
    );
    
    if (newBarcodes.length === 0) {
      throw new Error('Geen geldige barcodes ontvangen van server');
    }
    
    return newBarcodes;
  } catch (error) {
    console.error('Error in generateMultipleBarcodes:', error);
    
    // Provide more specific error messages
    if (error.response) {
      console.error('Server error response:', error.response);
      throw new Error(`Server fout (${error.response.status}): ${error.response.statusText}`);
    } else if (error.request) {
      throw new Error('Geen response van server ontvangen - controleer netwerkverbinding');
    } else {
      throw error;
    }
  }
};

  const delete_barcodes = () => {
    // delete selected barcodes
    selectedVariationIds.forEach((selectedId) => {
      let vari = props.allVariations.find(
        (variation) => variation.id == selectedId
      );
      if (vari.barcode != null || vari.barcode != "") {
        props.setAllVariations((prevVariations) =>
          prevVariations.map((variation) =>
            variation.id === vari.id
              ? {
                ...variation,
                barcode: { ...variation.barcode, barcode: null },
              }
              : variation
          )
        );
        updatePagination();
      }
    });
    
    // Add this line to trigger the database update
    props.setUpdatedVariations(true);
    
    // Clear selection after deletion
    setSelectedVariationIds([]);
  };

  const delete_variations = () => {
    props.setAllVariations((previous) =>
      previous.filter(
        (variation) => !selectedVariationIds.includes(variation.id)
      )
    );
    setSizeFilter("");
    setColorFilter("");
    setSelectedVariationIds([]);
  };

  const handleAction = async (event) => {
    if (event === "generate-barcodes") {
      generate_barcodes();
    } else if (event === "delete-barcodes") {
      delete_barcodes();
    } else if (event === "delete") {
      delete_variations();
      props.setUpdatedVariations(true);
    } else if (event === "print-labels") {
      // Convert selectedVariationIds (variation IDs) to product IDs for label generation
      const productIds = selectedVariationIds.map(variationId => {
        const variation = props.allVariations.find(v => v.id === variationId);
        return variation?.product_id;
      }).filter(productId => productId != null); // Remove any null/undefined values
      
      // If no product IDs were found, show a clear message instead of letting the server return 404
      if (!productIds || productIds.length === 0) {
        ToastError('Selecteer eerst één of meer variaties om labels te genereren', 'label_generate_error', 3000);
        return;
      }

      try {
        await generateLabel(productIds);
      } catch (err) {
        console.error('Error generating labels:', err);
        ToastError('Fout bij het genereren van labels: ' + (err?.message || 'Onbekende fout'), 'label_generate_error');
      }
    }
  };

  const generateBarcode = async (event, id) => {
    if (event != null) {
      event?.preventDefault();
    }

    const currentVariation = props.allVariations.find((v) => v.id === id) || {};
    const barcodeVal = currentVariation?.barcode?.barcode ?? (typeof currentVariation?.barcode === 'string' ? currentVariation.barcode : null);
    const hasBarcode = barcodeVal != null && String(barcodeVal).trim() !== "";

    if (hasBarcode) {
      pendingConfirmActionRef.current = () => performGenerateBarcode(id);
      setShowGenerateConfirm(true);
      return;
    }

    await performGenerateBarcode(id);
  };

  const performGenerateBarcode = async (id) => {
    try {
      const response = await middleware.get("products/generateBarcode");
      const newBarcode = response.data.generatedBarcode;

      handleBarcodeChange(newBarcode, id);
      // Set the pagination so the generated barcode is visible
      updatePagination();
    } catch (err) {
      console.error('Fout bij genereren barcode:', err);
      ToastError('Kon geen barcode genereren. Probeer het later opnieuw.');
    }
  };

  const performBulkGenerate = async (ids = []) => {
    try {
      if (!ids || ids.length === 0) return;
      const generated = await generateMultipleBarcodes(ids.length);
      let count = 0;
      ids.forEach((selectedId) => {
        const vari = props.allVariations.find((v) => v.id == selectedId);
        if (!vari) {
          count++;
          return;
        }
        handleBarcodeChange(generated[count], vari.id);
        count++;
      });

      updatePagination();

      props.setUpdatedVariations(true);
    } catch (err) {
      console.error('Fout bij bulk genereren barcodes:', err);
      ToastError('Fout bij bulk genereren barcodes');
    }
  };

  const handleFilterChange = (value, field) => {
    if (field === "size") {
      setSizeFilter(value);
    } else if (field === "color") {
      setColorFilter(value);
    }
    checkIfVariationExists(value, field);
  };

  const checkIfVariationExists = (value, field) => {
    const { allVariations, allSizes, allColors } = props;

    if (field === "size") {
      // Als er geen maat in allSizes zit met dezelfde id, toon een alert.
      if (!allSizes.find((size) => size.size_id === value)) {
      }
    } else if (field === "color") {
      // Als er geen kleur in allColors zit met dezelfde id, toon een alert.
      if (!allColors.find((color) => color.color_id === value)) {
      }
    }
  };

  // Replace existing handleBarcodeChange with enhanced version
const handleBarcodeChange = async (newBarcode, id) => {
  // Remove only errors for this specific id
  props.setErrors((prevErrors) => 
    prevErrors.filter(error => 
      typeof error === 'object' ? error.id !== id : error !== id
    )
  );
  
  // Check if barcode already exists in other variations
  const existingVariation = props.allVariations.find(
    (variation) => 
      variation.id !== id && // Exclude current variation
      variation.barcode?.barcode === newBarcode &&
      newBarcode !== "" && 
      newBarcode !== null
  );
  
  if (existingVariation) {
    props.setErrors([
      ...props.errors, 
      { 
        id: id, 
        code: 'existing_barcode',
      }
    ]);
  }

  if(newBarcode.length>25||!newBarcode.match('^[a-zA-Z0-9]*$')){
    props.setErrors([
      ...props.errors, 
      { 
        id: id, 
        code: 'Niet geldig',
      }
    ]);
    ToastError('Ongeldige barcode','incorrect_barcode');
  }
  
  // Check if this is actually a change
  const currentVariation = props.allVariations.find((variation) => variation.id === id);
  const currentBarcode = currentVariation?.barcode?.barcode;
  
  if (newBarcode !== currentBarcode) {
    props.setUpdatedVariations(true);
  }
  
  // Update local state
  props.setAllVariations((prevVariations) =>
    prevVariations.map((variation) =>
      variation.id === id
        ? {
          ...variation,
          barcode: { ...variation.barcode, barcode: newBarcode },
        }
        : variation
    )
  );
  
  // Rerender variations
  updatePagination();
};

  const handleStockChange = (newStock, id) => {
    // set the updated stock to true if the field changes
    if (
      newStock !=
      props.allVariations.find((variation) => variation.id === id)?.stock?.commercial_quantity ??
      null
    ) {
      props.setUpdatedVariations(true);
    }
    props.setAllVariations((prevVariations) =>
      prevVariations.map((variation) =>
        variation.id === id
          ? {
            ...variation,
            stock: {
              ...variation.stock,
              commercial_quantity: parseFloat(newStock) || 0,
              stock_behavior: 0,
              deliverability: 0,
            }
          }
          : variation
      )
    );
  };

  // Updated isValid function to correctly handle string and number values
  const isValid = (val) => {
    // If val is a string, we need to handle it differently than if it's a number
    if (typeof val === 'string') {
      // Trim any whitespace
      const trimmed = val.trim();
      // Check if it's empty or just "0" or "0.00"
      return trimmed !== "" && trimmed !== "0" && trimmed !== "0.00";
    }

    // If val is a number, make sure it's not 0
    if (typeof val === 'number') {
      return val !== 0;
    }

    // If val is null or undefined, it's not valid
    return val !== null && val !== undefined;
  };

  // Updated onPriceButtonClicked function with the new isValid function
  const onPriceButtonClicked = (event, variationId) => {
    const productVariation = props.allVariations.find((v) => v.id === variationId);
    if (!productVariation) {
      console.error(`No variation found for variationId: ${variationId}`);
      return;
    }

    const operator = event.target.innerHTML.trim(); // "+" or "-"
    if (operator === productVariation.variation_operator) {
      return; // Skips if the user clicks on the same operator
    }
    
    let newVariationPrice = productVariation.variation_price;
    if (newVariationPrice !== null) {
      newVariationPrice = String(newVariationPrice || '')?.replace('-', '');
      if (operator === '-') {
        newVariationPrice = '-' + newVariationPrice;
      }
    }

    props.setAllVariations((prev) =>
      prev.map((v) =>
        v.id === variationId ? {
          ...v,
          variation_price: newVariationPrice,
          variation_operator: operator
        } : v
      )
    );
    if (newVariationPrice !== null) {
      props.setUpdatedVariations(true);
    }
  };

  // Updated calculateFinalPrice function with the new isValid function
  const calculateFinalPrice = (variation) => {
    const pricesArray = props.prices ?? [];

    // Get the sale and regular prices
    const salePriceItem = pricesArray.find(item => item.type === "sale_price");
    const regularPriceItem = pricesArray.find(item => item.type === "price");

    const salePrice = salePriceItem?.incl_tax;
    const regularPrice = regularPriceItem?.incl_tax;

    // Set the base price
    let basePrice = 0;

    // First check if there's a valid sale price
    if (isValid(salePrice)) {
      basePrice = Number(salePrice);
    }
    // If no valid sale price, use the regular price
    else if (isValid(regularPrice)) {
      basePrice = Number(regularPrice);
    }

    // Extra info that has been added to the variation
    let extra=0;
    if(typeof variation.variation_price==="string")
    extra = Number(variation.variation_price?.replace(',','.'));

    // Calculate the final price
    let finalPrice = 0;
    finalPrice = basePrice + extra;

    if (finalPrice < 0) {
      ToastError("Prijs werd automatisch aangepast omdat hij negatief werd.","NegativeVal", 2500);
      finalPrice = 0;
    }

    return finalPrice;
  };

  const handleVariationPriceChange = (price, variationId) => {
    const productVariation = variations.find((v) => v.id === variationId);
    if (!productVariation) {
      console.error("No variation found for variationId:", variationId);
      return;
    }

    let newPrice = price?.replace('-', '');
    if (productVariation.variation_operator === '-') {
      newPrice = '-' + newPrice;
    }

    props.setAllVariations((prevVariations) =>
      prevVariations.map((variation) =>
        variation.id === variationId
          ? { ...variation, variation_price: price !== undefined ? newPrice : undefined }
          : variation
      )
    );
  };

  const handleVariationBuyInPriceChange = (value, variationId) => {
    const numVal = value ? String(value).replace(',', '.') : '';
    const inclTax = numVal
      ? (parseFloat(numVal) * (1 + (props.selectedTax || 0) / 100)).toFixed(2)
      : '';

    props.setAllVariations((prevVariations) =>
      prevVariations.map((variation) => {
        if (variation.id !== variationId) return variation;
        const existingPrices = variation.prices ?? [];
        const existingBuyIn = existingPrices.find((p) => p.type === 'buy_in_price');
        const hasBuyIn = !!existingBuyIn;
        if (!numVal) {
          if (existingBuyIn?.price_id) {
            return {
              ...variation,
              prices: existingPrices.map((p) =>
                p.type === 'buy_in_price'
                  ? { type: 'buy_in_price', price_id: p.price_id, deleted: true }
                  : p
              ),
            };
          }
          return { ...variation, prices: existingPrices.filter((p) => p.type !== 'buy_in_price') };
        }
        return {
          ...variation,
          prices: hasBuyIn
            ? existingPrices.map((p) =>
                p.type === 'buy_in_price' ? { ...p, excl_tax: numVal, incl_tax: inclTax } : p
              )
            : [...existingPrices, { price_id: null, type: 'buy_in_price', excl_tax: numVal, incl_tax: inclTax }],
        };
      })
    );
    props.setUpdatedVariations(true);
  };

  const focusedId = useRef();
  const carrotRef= useRef();

  const columns = useMemo(() => {
      // Base columns
      const cols = [
        {
          Header: (
            <div className="d-flex justify-content-center align-items-center" style={{ width: '60px' }}>
              <RegularCheckBox
                label=""
                value={selectedVariationIds.length > 0 && selectedVariationIds.length === variations.length}
                setValue={(checked) => {
                  setSelectedVariationIds(
                    checked ? variations.map((v) => v.id) : []
                  );
                }}
              />
            </div>
          ),
          accessor: "select",
          width: 60,
          minWidth: 60,
          maxWidth: 60,
          Cell: ({ row }) => {
            const isSelected = selectedVariationIds.includes(row.original.id);
            return (
              <div className="d-flex justify-content-center align-items-center" style={{ width: '60px' }}>
                <RegularCheckBox
                  label=""
                  value={isSelected}
                  setValue={(checked) =>
                    handleProductSelection(row.original.id, checked)
                  }
                />
              </div>
            );
          },
        },
        ...(duplicateInstalled?.apps?.find(app => app.slug === "variabel-product-number")?.status === 3 ? [{
          Header: (
            <div className="d-flex justify-content-center align-items-center fw-bold" style={{ minWidth: '200px' }}>
              Artikelnummer
            </div>
          ),
          accessor: "product_number",
          width: 'auto',
          minWidth: 200,
          Cell: ({ row }) => {
            const id = row.original.id;
            const currentVariation =
              props.allVariations.find((v) => v.id === row.original.id) || {};

            const [localArticle, setLocalArticle] = useState(
              currentVariation?.product_number ?? currentVariation?.number ?? currentVariation?.artikelnummer ?? ""
            );
            const inputRef = useRef();
            const iid = `${id}article`;

            useEffect(() => {
              if (inputRef?.current && focusedId.current === iid) inputRef.current.focus();
            }, [inputRef]);

            const updateArticle = () => {
              setTimeout(() => {
                const newVal = String(localArticle || "").trim();
                const maxLen = 255;
                if (newVal.length > maxLen) {
                  ToastError(`Artikelnummer mag maximaal ${maxLen} karakters bevatten`);
                  return;
                }
                props.setAllVariations((prev) =>
                  prev.map((variation) =>
                    variation.id === id
                      ? {
                          ...variation,
                          product_number: newVal || null,
                          number: newVal || null,
                          artikelnummer: newVal || null,
                        }
                      : variation
                  )
                );
                props.setUpdatedVariations(true);
              }, 100);
            };

            return (
              <div className="d-flex justify-content-center align-items-center px-2">
                  <div style={{ minWidth: '150px', maxWidth: '220px' }}>
                    <BorderedSquareTextInput
                      size="l"
                      placeholder="Artikelnummer"
                      inputValue={localArticle}
                      setInputValue={setLocalArticle}
                      updateFunction={updateArticle}
                      updateWaitTimer={null}
                      ref={inputRef}
                      onFocus={() => (focusedId.current = iid)}
                      onBlur={() => (focusedId.current = null)}
                      useModifiedBlur={true}
                    />
                  </div>
              </div>
            );
          },
        }] : []),
        {
          Header: (
            <div className="d-flex justify-content-center align-items-center fw-bold">
              Voorraad
            </div>
          ),
          accessor: "stock",
          width: 120,
          minWidth: 120,
          maxWidth: 120,
          Cell: ({ row }) => {
            const id = row.original.id;
            const currentVariation =
              props.allVariations.find((v) => v.id === row.original.id) || {};
            const stockValue = currentVariation.stock?.commercial_quantity ?? "";
            const [localStock, setLocalStock] = useState(stockValue);
            const inputRef = useRef();
            const iid= `${id}-stock`;

            useEffect(()=>{
              if(inputRef?.current&&focusedId.current===iid)inputRef.current.focus();
            },[inputRef])

            const updateStock = () => {
              setTimeout(()=>{
                // Ensure localStock is a string before calling replace
                const stockString = String(localStock || "");
                const normalizedStock = stockString.replace(/^0+/, "") || "0"; // Remove leading zeros
                handleStockChange(normalizedStock, id);
              },100);
            };
  
            return (
              <div
                className="d-flex justify-content-center align-items-center px-2"
              >
                <div style={{ width: '60px' }}>
                  <BorderedSquareNumberInput
                    size="l"
                    placeholder="0"
                    inputValue={localStock === 0 ? '' : localStock}
                    setInputValue={setLocalStock}
                    updateFunction={updateStock}
                    updateWaitTimer={null}
                    ref={inputRef}
                    onFocus={() => focusedId.current=iid}
                    onBlur={() => focusedId.current=null}
                    useModifiedBlur={true}
                  />
                </div>
              </div>
            );
          },
        },
        ...(duplicateInstalled?.apps?.find(app => app.slug === "variable-purchase-price")?.status === 3 ? [{
          Header: (
            <div className="d-flex justify-content-center">Inkoop prijs</div>
          ),
          accessor: "buy_in_price",
          Cell: ({ row }) => {
            const variationId = row.original.id;
            const variationData = props.allVariations.find((v) => v.id === variationId);
            const buyInPrice = variationData?.prices?.find(p => p.type === 'buy_in_price')?.excl_tax ?? '';
            const productBuyInPrice = props.prices?.find(p => p.type === 'buy_in_price')?.excl_tax;
            const inputRef = useRef();
            const iid = `${variationId}-buy-in-price`;
            const [localBuyIn, setLocalBuyIn] = useState(buyInPrice);

            useEffect(() => {
              if (inputRef?.current && focusedId.current === iid) {
                inputRef.current.focus();
              }
            }, [inputRef]);

            useEffect(() => {
              if (focusedId.current !== iid) {
                setLocalBuyIn(buyInPrice);
              }
            }, [buyInPrice]);

            const updateBuyIn = () => {
              setTimeout(() => {
                handleVariationBuyInPriceChange(localBuyIn, variationId);
              }, 100);
            };

            return (
              <div className="d-flex justify-content-center">
                <CurrencyInput
                  placeholder={productBuyInPrice ? `€ ${productBuyInPrice}` : '€ 0.00'}
                  className="stockBox variablePriceBox px-2"
                  decimalsLimit={2}
                  prefix="€ "
                  step={0.01}
                  min={0}
                  name={`${variationId}-buy-in`}
                  value={localBuyIn !== '' ? localBuyIn : ''}
                  onValueChange={(value) => {
                    setLocalBuyIn(value ?? '');
                  }}
                  formatValueOnBlur={false}
                  onBlur={() => { focusedId.current = null; updateBuyIn(); }}
                  onFocus={() => (focusedId.current = iid)}
                  ref={inputRef}
                />
              </div>
            );
          },
        }] : []),
        {
          Header: (
            <div className="d-flex justify-content-center align-items-center fw-bold" style={{ minWidth: '200px' }}>
              Barcode
            </div>
          ),
          accessor: "barcode",
          width: 'auto',
          minWidth: 200,
          Cell: ({ row }) => {
            const id = row.original.id;
            const currentVariation =
              props.allVariations.find((v) => v.id === row.original.id) || {};

            const barcodeValue = currentVariation.barcode?.barcode || "";
            const [localBarcode, setLocalBarcode] = useState(barcodeValue);
            const inputRef = useRef();
            const iid= `${id}-barcode`;

              useEffect(() => {
                if(inputRef?.current&&focusedId.current===iid)inputRef.current.focus();
            }, [inputRef]);

            const updateBarcode = () => {
            setTimeout(()=>{
              handleBarcodeChange(localBarcode, id);
            },100);
            };
  
            return (
              <div className="d-flex justify-content-center align-items-center gap-2 px-2">
                <div style={{ minWidth: '150px', maxWidth: '200px' }}>
                  <BorderedSquareTextInput
                    size="l"
                    placeholder="Barcode (ISBN, etc.)"
                    inputValue={localBarcode}
                    setInputValue={setLocalBarcode}
                    updateFunction={updateBarcode}
                    updateWaitTimer={null}
                    error={props.errors.find((error) => error.id === row.original.id)}
                    ref={inputRef}
                    onFocus={() => focusedId.current=iid}
                    onBlur={() => focusedId.current=null}
                    useModifiedBlur={true}
                  />
                </div>
                <div
                  className="d-flex justify-content-center align-items-center generateBarcodeBtn"
                  onClick={(e) => generateBarcode(e, row.original.id)}
                  style={{ cursor: 'pointer', minWidth: '30px' }}
                >
                  <FontAwesomeIcon icon={faBarcode} />
                </div>
              </div>
            );
          },
        },
        ...(duplicateInstalled?.apps?.find(app => app.slug === "variable-product-price")?.status === 3 ? [{
          Header: (
            <div className="d-flex justify-content-center">Variabele prijs</div>
          ),
          accessor: "incl_tax",
          Cell: ({ row }) => {
            const variationId = row.original.id;
            const variationData = variations.find((v) => v.id === variationId);
            const operator = variationData?.variation_operator || null;
            const iid=`${variationId}-price`;
            const inputRef=useRef();
  
            useEffect(()=>{
              if(inputRef?.current&&focusedId.current===iid)inputRef.current.focus();
              if (carrotRef.current)
                inputRef.current.setSelectionRange(
                  carrotRef.current,
                  carrotRef.current
                );
            },[inputRef])
            return (
              <div className="d-flex justify-content-center gap-1">
                <div className="d-flex justify-content-center flex-row">
                  <div
                    className={
                      operator === "+"
                        ? "VariationPriceBtnPlusSelected"
                        : "VariationPriceBtnPlus"
                    }
                    onClick={(e) => onPriceButtonClicked(e, variationId)}
                  >
                    +
                  </div>
                  <div
                    className={
                      operator === "-"
                        ? "VariationPriceBtnMinusSelected"
                        : "VariationPriceBtnMinus"
                    }
                    onClick={(e) => onPriceButtonClicked(e, variationId)}
                  >
                    -
                  </div>
                </div>
                <CurrencyInput
                  disabled={operator == null}
                  placeholder="€ 0,00"
                  className={`stockBox variablePriceBox px-2 ${
                    operator == null
                      ? "disabled-input"
                      : ""
                  }`}
                  prefix="€ "
                  step={0.01}
                  min={0}
                  name={`${variationId}`}
                  value={String(variationData.variation_price || '')?.replace('-', '') ?? null}
                  onValueChange={(value) =>{
                    carrotRef.current=inputRef.current.selectionStart===1?3:inputRef.current.selectionStart;
                    handleVariationPriceChange(value, variationId);
                  }}
                  formatValueOnBlur={false}
                  onBlur={() => {
                    focusedId.current = null;
                    props.setAllVariations(vari =>vari.map(e => e.id === variationId ?
                      {...e, variation_price: String(e.variation_price || '')?.replace(',','.') || null}
                      :
                      e
                    ));
                    props.setUpdatedVariations(true);
                  }}
                  onFocus={() => focusedId.current=iid}
                  ref={inputRef}
                />
              </div>
            );
          },
        }] : []),
        ...(duplicateInstalled?.apps?.find(app => app.slug === "variable-product-price")?.status === 3 ? [{
          accessor: "finalPrice",
          Cell: ({ row }) => {
            return (
              <div className="text-nowrap">
                <span className="align-self-center">
                  = {formatCurrency(
                    calculateFinalPrice(
                      variations.find((e) => e.id === row.original.id)
                    )
                  )}
                </span>
              </div>
            );
          },
        }] : []),
      ];

      if (props.allVariations.find((e) => e.colors && e.colors.length !== 0)) {
        cols.splice(1, 0, {
          Header: (
            <div className="d-flex justify-content-center align-items-center">
            <select
                style={{ borderRadius: '100px', minWidth: '120px' }}
              value={colorFilter}
              onChange={(e) => handleFilterChange(e.target.value, "color")}
                className="form-select form-select-sm fw-bold text-center"
            >
              <option value="">Filter kleur</option>
              {props.allColors
                .filter((e) =>
                  props.allVariations.find((b) => b.color_name === e.name)
                )
                .map((e, index) => (
                  <option key={index} value={e.color_id}>
                    {e.name}
                  </option>
                ))}
            </select>
            </div>
          ),
          accessor: "color_name",
          Cell: ({ row }) => {
            return row.original.colors.length > 0 &&
              row.original.colors[0]?.name ? (
              <div 
                className="d-flex justify-content-center align-items-center" 
              >
                <div
                  className="rounded-circle me-2"
                  style={{
                    backgroundColor: row.original.colors[0]?.hex,
                    width: "15px",
                    height: "15px",
                    flexShrink: 0,
                  }}
                ></div>
                <div
                  className="text-nowrap text-truncate"
                  style={{ maxWidth: '100px' }}
                  title={row.original.colors[0].name}
                >
                  {row.original.colors[0].name}
                </div>
              </div>
            ) : (
              ""
            );
          },
        });
      }

      // Conditionally add a column for size if any variation has sizes
      if (props.allVariations.find((e) => e.sizes && e.sizes.length !== 0)) {
        cols.splice(
          props.allVariations.find((e) => e.colors && e.colors.length !== 0)
            ? 2
            : 1,
          0,
          {
            Header: (
              <div className="d-flex justify-content-center align-items-center">
                <select
                  className="form-select form-select-sm fw-bold text-center"
                  style={{ borderRadius: '100px', minWidth: '120px' }}
                  value={sizeFilter}
                  onChange={(e) => handleFilterChange(e.target.value, "size")}
                >
                  <option value="">Filter maat</option>
                  {props.allSizes
                    .filter((e) =>
                      props.allVariations.find(
                        (b) =>
                          b.sizes &&
                          b.sizes.length > 0 &&
                          b.sizes[0].main === e.main
                      )
                    )
                    .map((e, index) => (
                      <option key={index} value={e.size_id}>
                        {e.main}
                      </option>
                    ))}
                </select>
              </div>
            ),
            accessor: "size_name",
            Cell: ({ row }) => (
              <span
                className="d-flex justify-content-center align-items-center fw-medium" 
              >
                {row.original.sizes[0]?.main ?? ""}
              </span>
            ),
          }
        );
      }
  
      return cols;
    }, [
      selectedVariationIds,
      props.errors,
  variations,
  colorVariations,
  sizeVariations,
  colorFilter,
  sizeFilter,
  props.prices
    ]);

  const tableInstance = useTable({ columns, data: variations });
  
  const handleNewVariation = async () => {
    const size = props.allSizes.find(
      (size) => size.size_id === Number(addVariation.size)
    );
    const color = props.allColors.find(
      (color) => color.color_id === Number(addVariation.color)
    );
    if (!size && !color) {
      ToastError("Je moet een maat of kleur selecteren");
      return;
    }
    if (
      props.allVariations.find(
        (e) =>
          e.colors[0]?.color_id === color?.color_id &&
          e.sizes[0]?.size_id === size?.size_id
      )
    ) {
      ToastError("Die variatie bestaat al");
      return;
    }
    // Do NOT auto-generate a barcode for manual variation creation.
    // Keep barcode as null so it won't be included in update payloads.
    const newVariation = {
      id: props.allVariations.length + 1,
      size: size?.size_id ?? null,
      size_name: size?.main ?? null,
      color: color?.color_id ?? null,
      color_name: color?.name ?? null,
      colors: color
        ? [
          {
            color_id: color?.color_id ?? null,
            name: color?.name ?? null,
            hex: color?.hex ?? null,
          },
        ]
        : [],
      sizes: size
        ? [
          {
            size_id: size?.size_id ?? null,
            main: size?.main ?? null,
          },
        ]
        : [],
      hex: color?.hex ?? null,
      prices: [{ type: "price", incl_tax: 0 }],
      stock: { commercial_quantity: 0 },
      // Start without a barcode; user can generate one via the UI.
      barcode: null,
      variation_operator: "+",
      variation_price: 0.0,
    };
    if (size) {
      setSizeVariations([size, ...sizeVariations]);
    }
    if (color) {
      setColorVariations([color, ...colorVariations]);
    }
    props.setAllVariations([newVariation, ...props.allVariations]);
    props.setUpdatedVariations(true);
    setAddVariation({ size: "", color: "" });
  };

  const actionOptionsArray = [
    ...(labelPrinterInstalled ? [{
      title: "Label(s) printen",
      function: () => handleAction("print-labels"),
    }] : []),
    {
      title: "Genereer barcodes",
      function: () => handleAction("generate-barcodes"),
    },
    {
      title: "Verwijder barcodes",
      function: () => handleAction("delete-barcodes"),
    },
    {
      title: "Verwijder",
      function: () => handleAction("delete"),
    },
  ];

  return (
    <>
      <div className="whiteBox p-5 formVariationProduct mb-4">
        <h5 className="fw-semibold">Huidige variaties</h5>
        <div className="widthColorTable">
            <TablePreset
              data={[
                {
                  selectedIds: selectedIds,
                  tableInstance: tableInstance,
                  pagination: pagination,
                },
              ]}
              mobileButtonsLeftVisable={true}
              tableLoading={false}
              setPagination={(e) => setPagination(e)}
              handleSelection={handleSelection}
              borderedDropDown={true}
              actionOptions={[
                ...(labelPrinterInstalled ? [{
                  title: "Label(s) printen",
                  onClick: () => handleAction("print-labels"),
                }] : []),
                {
                  title: "Genereer barcodes",
                  onClick: () => handleAction("generate-barcodes"),
                },
                {
                  title: "Verwijder barcodes",
                  onClick: () => handleAction("delete-barcodes"),
                },
                {
                  title: "Verwijder",
                  onClick: () => handleAction("delete"),
                },
              ]}
              rightDropdowns={[
                {
                  placeholder: "Selecteer een maat",
                  selectedValue: addVariation.size,
                  setSelectedValue: (val) => setAddVariation((prev) => ({ ...prev, size: val })),
                  options: props.allSizes.map((size) => ({
                    title: size.main,
                    value: size.size_id,
                  })),
                },
                {
                  placeholder: "Selecteer een kleur",
                  selectedValue: addVariation.color,
                  setSelectedValue: (val) => setAddVariation((prev) => ({ ...prev, color: val })),
                  options: props.allColors.map((color) => ({
                    title: color.name,
                    value: color.color_id,
                  })),
                },
              ]}
              rightButtons={[
                { title: "Variatie aanmaken", function: handleNewVariation },
              ]}
              noPadding={true}
            />
        </div>
      </div>
        <ConfirmationModal
          showConfirmation={showGenerateConfirm}
          setShowConfirmation={setShowGenerateConfirm}
          acceptationFunction={() => {
            if (pendingConfirmActionRef.current) {
              pendingConfirmActionRef.current();
              pendingConfirmActionRef.current = null;
            }
          }}
          message={"Weet je zeker dat je de barcode wil overschrijven?"}
          acceptButtonText={"Ja, overschrijven"}
          cancelButtonText={"Nee, annuleren"}
        />
    </>
  );
};

export default BoxVariation;
